import { motion } from "framer-motion";
import { MessageSquare, BarChart3, FileText } from "lucide-react";

const features = [
  {
    icon: MessageSquare,
    text: 'Ask "Why did fuel expenses spike this month?" | Genie explains from your Tally data.',
  },
  {
    icon: BarChart3,
    text: "Get bill/client‑wise tables/charts for sales, purchases, receipts, payments etc.",
  },
  {
    icon: FileText,
    text: "Use natural language to generate analysis for partner reviews and client meetings; without exporting to Excel every time!",
  },
];

const AskTally = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-4"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Ask Tally Anything
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Your review console for every client.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="bg-card rounded-2xl p-8 md:p-12 border border-border card-elevated max-w-6xl mx-auto mt-12"
        >
          <div className="space-y-6">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                className="flex items-start gap-4"
              >
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-5 h-5 text-primary" />
                </div>
                <p className="text-foreground leading-relaxed pt-2">{feature.text}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AskTally;
